// Centralized version management

// Import version from package.json
import packageJson from '../../package.json';

// App version - automatically read from package.json
export const APP_VERSION = packageJson.version;
export const APP_NAME = "Holifya";

// SECRET VERSION TRIGGER FEATURE:
// 
// Desktop: Press Shift + V, Ctrl/Cmd + Shift + V, or Ctrl/Cmd + Alt + V
// Mobile: 3-finger long press (hold for 2 seconds) or triple tap the version indicator
// 
// This will show a popup with the current app version and build date.
// The version indicator is only visible in development mode.

// Format version for display (add 'v' prefix)
export const RELEASE_VERSION = `v${APP_VERSION}`;

// Get build info from environment or fallback
export const BUILD_INFO = {
  version: APP_VERSION,
  buildTime: process.env.REACT_APP_BUILD_TIME || new Date().toISOString(),
  commitHash: process.env.REACT_APP_COMMIT_HASH || 'dev',
  environment: process.env.NODE_ENV || 'development'
};

// Expose version to global scope for dev tools access
if (typeof window !== 'undefined') {
  (window as any).APP_VERSION = APP_VERSION;
  (window as any).RELEASE_VERSION = RELEASE_VERSION;
  (window as any).BUILD_INFO = BUILD_INFO;
  
  // Add a helper function to check for updates
  (window as any).checkForUpdates = () => {
    fetch('/version.json')
      .then(response => response.json())
      .then(data => {
        console.log('🔄 Update Check:');
        console.log('  Current app version:', APP_VERSION);
        console.log('  Server version:', data.version);
        console.log('  Update available:', data.version !== APP_VERSION);
        console.log('  Build time:', data.buildTime);
      })
      .catch(error => console.error('Failed to check for updates:', error));
  };
}

// Export for backward compatibility
export default RELEASE_VERSION; 